import { LDClient, initialize } from "launchdarkly-js-client-sdk";

let ldClient: LDClient | null = null;

export function initializeLDClient(
  clientSideID: string,
  user: { email?: string; companyId?: string },
) {
  if (typeof window === "undefined") return null;

  if (!ldClient) {
    ldClient = initialize(clientSideID, {
      kind: "multi",
      user: {
        key: user.email,
      },
      company: {
        key: user.companyId,
      },
    });
  }

  return ldClient;
}

export function getLDClient() {
  return ldClient;
}
